import { User } from '@/models/assignato/user';
import { Storage } from '@capacitor/storage';


export const setToken = async (token: string) => {
    await Storage.set({
        key: 'token',
        value: token
    });
};

export const setUser = async (user: User) => {
    await Storage.set({
        key: 'user',
        value: JSON.stringify(user)
    });
};

export const getUser = async (): Promise<User> => {
    let user = new User();
    const result = await Storage.get({ key: 'user' });
    if (result && result.value) {
        user = JSON.parse(result.value) as User;
    }

    return user;
}

export const removeUser = async () => {
    await Storage.remove({
        key: 'user'
    });
};

export const changeLanguage = async (value: string) => {
    await Storage.set({
        key: 'language',
        value
    });
}

export const getLanguage = async () => {
    let language = '';
    const result = await Storage.get({ key: 'language' });
    if (result && result.value) {
        language = result.value;
    }

    return language;
}